import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import {
  defaultHomeContent, defaultAboutContent, defaultHowWeHelpContent,
  defaultContactContent, defaultDonateContent,
  defaultCorporateLifeSeriesContent, defaultServicesContent,
  defaultKnowledgeHubContent, defaultMembershipContent, defaultEventsContent
} from '../siteContent';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const deepMerge = (base, over) => {
  if (over === undefined || over === null) return base;
  if (Array.isArray(base) || Array.isArray(over)) return over;
  if (typeof base === 'object' && base !== null && typeof over === 'object') {
    const out = { ...base };
    Object.keys(over).forEach((k) => { out[k] = deepMerge(base[k], over[k]); });
    return out;
  }
  return over;
};

const DEFAULTS = {
  home: defaultHomeContent,
  about: defaultAboutContent,
  howwehelp: defaultHowWeHelpContent,
  contact: defaultContactContent,
  donate: defaultDonateContent,
  corporatelifeseries: defaultCorporateLifeSeriesContent,
  services: defaultServicesContent,
  knowledgehub: defaultKnowledgeHubContent,
  membership: defaultMembershipContent,
  events: defaultEventsContent
};

const SiteContentContext = createContext({ ...DEFAULTS, refresh: () => {} });

export const useSiteContent = () => useContext(SiteContentContext);

export const SiteContentProvider = ({ children }) => {
  const [state, setState] = useState(DEFAULTS);

  const refresh = useCallback(() => {
    const keys = Object.keys(DEFAULTS);
    Promise.all(keys.map((k) => axios.get(`${API}/content/${k}`).then((r) => r.data?.data || {}).catch(() => ({}))))
      .then((results) => {
        const next = {};
        keys.forEach((k, i) => { next[k] = deepMerge(DEFAULTS[k], results[i]); });
        setState(next);
      });
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <SiteContentContext.Provider value={{ ...state, refresh }}>
      {children}
    </SiteContentContext.Provider>
  );
};
